module.exports = __webpack_public_path__ + "img/wild.7e08ef73.png";